"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("../sigma/main");

require("../sigma/svg");

/**
  Component enables SVG renderer.
**/
function SigmaEnableSVG() {
  return null;
}

var _default = SigmaEnableSVG;
exports.default = _default;